export default __webpack_public_path__ + "8310b7db9510465f896b8add438fa0fd.png";